import HomeChecklist from "./HomeChecklist";
import LoginGate from "./components/LoginGate";
import UserChip from "./components/UserChip";
import { AuthProvider, useAuth } from "./lib/auth";

export default function App() {
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  );
}

function Gate() {
  const { state } = useAuth();

  if (state.status === "loading") {
    return <FullPageMessage>Loading…</FullPageMessage>;
  }
  if (state.status === "signedOut") {
    return <LoginGate />;
  }
  return (
    <>
      <UserChip />
      <HomeChecklist />
    </>
  );
}

function FullPageMessage({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fdf6ec",
        color: "#b07a80",
        fontFamily: "'Georgia', serif",
        fontSize: 14,
      }}
    >
      {children}
    </div>
  );
}
